export default __webpack_public_path__ + "static/media/image-4.918029f1.png";